<form class="wrapper" data-testid="drawing-sheet-edit-panel" aria-label="Edit sheet" (submit)="$event.preventDefault(); save()">
  <div>
    <div class="heading text-type-2" role="heading" aria-level="2" data-testid="drawing-sheet-edit-heading">Edit sheet</div>
    @if (data.host.editSheetLabel) {
      <p class="sub mat-body-1" data-testid="drawing-sheet-edit-label">{{ data.host.editSheetLabel }}</p>
    }
  </div>

  <div class="fields">
    <label class="field">
      <span class="field-label">Number</span>
      <input class="field-input" name="number" maxlength="64" data-testid="drawing-sheet-edit-number" [value]="draft.number" [disabled]="saving"
        (input)="set('number', $any($event.target).value)" />
    </label>
    <label class="field">
      <span class="field-label">Title</span>
      <input class="field-input" name="title" maxlength="256" data-testid="drawing-sheet-edit-title" [value]="draft.title" [disabled]="saving"
        (input)="set('title', $any($event.target).value)" />
    </label>
    <div class="field-row">
      <label class="field">
        <span class="field-label">Discipline</span>
        <input class="field-input" name="discipline" maxlength="64" placeholder="Civil" data-testid="drawing-sheet-edit-discipline" [value]="draft.discipline"
          [disabled]="saving" (input)="set('discipline', $any($event.target).value)" />
      </label>
      <label class="field">
        <span class="field-label">Type</span>
        <select class="field-input" name="sheet_type" data-testid="drawing-sheet-edit-type" [disabled]="saving" (change)="set('sheetType', $any($event.target).value)">
          <option value="" [selected]="!draft.sheetType">Other</option>
          @for (t of sheetTypes; track t.value) {
            <option [value]="t.value" [selected]="t.value === draft.sheetType">{{ t.label }}</option>
          }
        </select>
      </label>
    </div>
    <div class="field-row">
      <label class="field">
        <span class="field-label">Station from</span>
        <input class="field-input" name="station_start" maxlength="16" placeholder="120+00" data-testid="drawing-sheet-edit-start" [value]="draft.start"
          [disabled]="saving" (input)="set('start', $any($event.target).value)" />
      </label>
      <label class="field">
        <span class="field-label">Station to</span>
        <input class="field-input" name="station_end" maxlength="16" placeholder="130+00" data-testid="drawing-sheet-edit-end" [value]="draft.end"
          [disabled]="saving" (input)="set('end', $any($event.target).value)" />
      </label>
    </div>
  </div>

  @if (error) {
    <!-- The error message (Figma 12036:48452), as the set review's page panel -->
    <div class="message message--error" role="alert" data-testid="drawing-sheet-edit-error">
      <mat-icon>error_outline</mat-icon><span>{{ error }}</span>
    </div>
  }

  <div class="panel-footer">
    <app-secondary-button buttonId="drawing-sheet-edit-cancel" [isDisabled]="saving" (handleClick)="cancel()">Cancel</app-secondary-button>
    <app-primary-button buttonId="drawing-sheet-edit-save" [isLoading]="saving" [isDisabled]="!changed || saving" (handleClick)="save()">Save</app-primary-button>
  </div>
</form>
